import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../../../utils/@reduxjs/toolkit';
import { ContainerState } from './types';
import { formDefaults } from './utils';

export const initialState: ContainerState = {
    data: null,
    isLoading: false,
    hasError: false,
    errorMessage: null,
    formData: formDefaults,
    formPayload: null,
    kinds: null,
    publicationDate: null,
};

const mainMenuSlice = createSlice({
    name: 'searchResults',
    initialState,
    reducers: {
        search(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                isLoading: true,
                hasError: false,
            };
        },
        searchNext(state: any, { payload }: PayloadAction<object | undefined>) {
            return {
                ...state,
                hasError: false,
            };
        },
        searchSuccess(state: any, { payload }: PayloadAction<object | null>) {    
            return {
                ...state,
                data: payload,
                isLoading: false,
                hasError: false,
            };
        },
        searchSuccessNext(state: any, { payload }: PayloadAction<object | null>) { 
                state.isLoading = false         
        },
        searchError(state: any, { payload }: PayloadAction<Error>) {
            return {
                ...state,
                isLoading: false,
                hasError: true,
                errorMessage: payload,
            };
        },
        setFormData(state: ContainerState, { payload }: any) {
            state.formData = {...payload};
        },
        setFormPayload(state: ContainerState, { payload }: any) { // Action to set formPayload
            state.formPayload = payload;
        },
        setKinds(state: ContainerState, { payload }: any) { // Action to set kinds
            state.kinds = payload;
        },
        setPublicationDate(state: ContainerState, { payload }: any) { // Action to set PublicationDate
            state.publicationDate= payload;
        },
        resetState() {
            return initialState;
        },
        clearError(state: any) {
            return {
                ...state,
                isLoading: false,
                hasError: false,
                errorMessage: null,
            };
        },
    },
});


export const { actions, reducer, name: sliceKey } = mainMenuSlice;
